module.exports = __webpack_public_path__ + "img/42.8b2c51f9.jpg";